export const FETCH_PRESCRIBER = 'FETCH_PRESCRIBER';
export const FETCH_PRESCRIBER_SUCCESS = 'FETCH_PRESCRIBER_SUCCESS';
export const FETCH_PRESCRIBER_FAILURE = 'FETCH_PRESCRIBER_FAILURE';

export const REFRESH_PRESCRIBER = 'REFRESH_PRESCRIBER';
export const REFRESH_PRESCRIBER_SUCCESS = 'REFRESH_PRESCRIBER_SUCCESS';
export const REFRESH_PRESCRIBER_FAILURE = 'REFRESH_PRESCRIBER_FAILURE';

export const UPDATE_PRESCRIBER = 'UPDATE_PRESCRIBER';
export const UPDATE_PRESCRIBER_SUCCESS = 'UPDATE_PRESCRIBER_SUCCESS';
export const UPDATE_PRESCRIBER_FAILURE = 'UPDATE_PRESCRIBER_FAILURE';

export const DEACTIVATE_PRESCRIBER = 'DEACTIVATE_PRESCRIBER';
export const DEACTIVATE_PRESCRIBER_SUCCESS = 'DEACTIVATE_PRESCRIBER_SUCCESS';
export const DEACTIVATE_PRESCRIBER_FAILURE = 'DEACTIVATE_PRESCRIBER_FAILURE';

export const REACTIVATE_PRESCRIBER = 'REACTIVATE_PRESCRIBER';
export const REACTIVATE_PRESCRIBER_SUCCESS = 'REACTIVATE_PRESCRIBER_SUCCESS';
export const REACTIVATE_PRESCRIBER_FAILURE = 'REACTIVATE_PRESCRIBER_FAILURE';

export const CREATE_PRESCRIBER = 'CREATE_PRESCRIBER';
export const CREATE_PRESCRIBER_SUCCESS = 'CREATE_PRESCRIBER_SUCCESS';
export const CREATE_PRESCRIBER_FAILURE = 'CREATE_PRESCRIBER_FAILURE';

export function fetchPrescriber(data) {
  return {
    type:    FETCH_PRESCRIBER,
    payload: data
  };
}

export function fetchPrescriberSuccess(response) {
  return {
    type:    FETCH_PRESCRIBER_SUCCESS,
    payload: response
  };
}

export function fetchPrescriberFailure(errors) {
  return {
    type:    FETCH_PRESCRIBER_FAILURE,
    payload: errors
  };
}

export function refreshPrescriber(data) {
  return {
    type:    REFRESH_PRESCRIBER,
    payload: data
  };
}

export function refreshPrescriberSuccess(response) {
  return {
    type:    REFRESH_PRESCRIBER_SUCCESS,
    payload: response
  };
}

export function refreshPrescriberFailure(errors) {
  return {
    type:    REFRESH_PRESCRIBER_FAILURE,
    payload: errors
  };
}

export function updatePrescriber(data) {
    return {
      type:    UPDATE_PRESCRIBER,
      payload: data
    };
  }
  
  export function updatePrescriberSuccess(response) {
    return {
      type:    UPDATE_PRESCRIBER_SUCCESS,
      payload: response
    };
  }
  
  export function updatePrescriberFailure(errors) {
    return {
      type:    UPDATE_PRESCRIBER_FAILURE,
      payload: errors
    };
  }

  export function deactivatePrescriber(data) {
    return {
      type:    DEACTIVATE_PRESCRIBER,
      payload: data
    };
  }
  
  export function deactivatePrescriberSuccess(response) {
    return {
      type:    DEACTIVATE_PRESCRIBER_SUCCESS,
      payload: response
    };
  }
  
  export function deactivatePrescriberFailure(errors) {
    return {
      type:    DEACTIVATE_PRESCRIBER_FAILURE,
      payload: errors
    };
  }

  export function reactivatePrescriber(data) {
    return {
      type:    REACTIVATE_PRESCRIBER,
      payload: data
    };
  }

  export function reactivatePrescriberSuccess(response) {
    return {
      type:    REACTIVATE_PRESCRIBER_SUCCESS,
      payload: response
    };
  }

  export function reactivatePrescriberFailure(errors) {
    return {
      type:    REACTIVATE_PRESCRIBER_FAILURE,
      payload: errors
    };
  }

  export function createPrescriber(data) {
    return {
      type:    CREATE_PRESCRIBER,
      payload: data
    };
  }

  export function createPrescriberSuccess(response) {
    return {
      type:    CREATE_PRESCRIBER_SUCCESS,
      payload: response
    };
  }

  export function createPrescriberFailure(errors) {
    return {
      type:    CREATE_PRESCRIBER_FAILURE,
      payload: errors
    };
  }
